import styled from 'styled-components';
import { Form } from '@unform/web';

export const Conteiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;
`;

export const ConteinerCard = styled.div`
  height: fit-content;
`;

export const ConteudoCard = styled.div`
  display: flex;

  padding: 10px;
`;

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;

  min-width: 300px;
  padding: 10px;
`;

export const TitleLogin = styled.h4`
  width: 100%;
  margin-bottom: 20px;

  text-align: center;
`;

export const AreaLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
`;

export const ConteinerCampo = styled.div`
  display: flex;
  flex-direction: column;

  margin: 10px 0;
`;
